var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalDetailsStepIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#2E77D0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "#CFCFCF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0693 15.0593C16.7425 15.0593 18.0989 13.7029 18.0989 12.0296C18.0989 10.3564 16.7425 9 15.0693 9C13.396 9 12.0396 10.3564 12.0396 12.0296C12.0396 13.7029 13.396 15.0593 15.0693 15.0593ZM9.00999 20.9771C9.03224 21.3999 9.2742 21.7522 9.96115 21.7522H20.0717C20.3652 21.7052 20.9594 21.4351 20.9876 20.7305C21.0522 20.0671 20.896 18.4442 19.7546 17.2606C19.4376 16.8907 18.5111 16.1015 17.3415 15.9043C17.1947 15.869 16.7919 15.8021 16.3551 15.8162H13.3783C12.9967 15.8221 12.0678 15.9289 11.4055 16.3094C10.5424 16.6382 8.85498 18.0321 9.00999 20.9771Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalDetailsStepIcon);
export default __webpack_public_path__ + "static/media/personal-details-step-icon.7953dca1a6d0b6252898a04fb163d154.svg";
export { ForwardRef as ReactComponent };